import { MapPin, Phone, Mail, Settings } from 'lucide-react';
import { Link } from 'react-router-dom';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_afc4fae4-3e91-49c0-b442-1e22d639f2c6/artifacts/5tm3hua0_Logo%20PF%402x.png";

const Footer = ({ settings, content }) => {
  const currentYear = new Date().getFullYear();
  const extra = content?.extra_fields || {};

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      const offset = 80;
      const top = element.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#1e3a8a] text-white" data-testid="footer">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <img 
                src={LOGO_URL} 
                alt="Place Financière BFC" 
                className="h-14 w-auto"
              />
            </div>
            <p className="text-white/70 font-inter leading-relaxed max-w-md mb-6">
              {content?.content || "Fédérer les acteurs économiques, financiers, juridiques et institutionnels au service du développement des entreprises en Bourgogne-Franche-Comté."}
            </p>
            <p className="text-sm text-white/50 font-inter">
              {extra.network_text || 'Membre du Réseau des Places Financières de France'}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-playfair text-lg font-semibold mb-6">
              {extra.nav_title || 'Navigation'}
            </h4>
            <ul className="space-y-3">
              {[
                { label: 'Accueil', href: '#hero' },
                { label: 'Qui sommes-nous', href: '#about' },
                { label: 'Nos missions', href: '#missions' },
                { label: 'Écosystème', href: '#ecosystem' },
                { label: 'Contact', href: '#contact' }
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollToSection(e, link.href)}
                    className="text-white/70 hover:text-[#D4AF37] font-inter text-sm transition-colors"
                    data-testid={`footer-link-${link.href.substring(1)}`}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-playfair text-lg font-semibold mb-6">
              {extra.contact_title || 'Contact'}
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#D4AF37] flex-shrink-0 mt-0.5" />
                <span className="text-white/70 font-inter text-sm">
                  {settings?.address || '2 avenue de Marbotte'}<br />
                  21000 Dijon
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-[#D4AF37] flex-shrink-0" />
                <a
                  href={`tel:${settings?.phone || '0380659100'}`}
                  className="text-white/70 hover:text-[#D4AF37] font-inter text-sm transition-colors"
                >
                  {settings?.phone || '03 80 65 91 00'}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-[#D4AF37] flex-shrink-0" />
                <a
                  href={`mailto:${settings?.email || 'contact@placefinanciere-bfc.fr'}`}
                  className="text-white/70 hover:text-[#D4AF37] font-inter text-sm transition-colors break-all"
                >
                  {settings?.email || 'contact@placefinanciere-bfc.fr'}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/50 font-inter text-sm text-center md:text-left">
              © {currentYear} {extra.copyright || 'Place Financière Bourgogne-Franche-Comté. Tous droits réservés.'}
            </p>
            <div className="flex items-center gap-6">
              <a
                href="/admin"
                className="flex items-center gap-2 bg-white/10 hover:bg-[#D4AF37] text-white/70 hover:text-white px-4 py-2 font-inter text-sm transition-all duration-300 rounded"
                data-testid="footer-admin-link"
              >
                <Settings className="w-4 h-4" />
                {extra.admin_link || 'Administration'}
              </a>
              <Link
                to="/mentions-legales"
                className="text-white/50 hover:text-[#D4AF37] font-inter text-sm transition-colors"
                data-testid="footer-legal-link"
              >
                {extra.legal_link || 'Mentions légales'}
              </Link>
              <Link
                to="/confidentialite"
                className="text-white/50 hover:text-[#D4AF37] font-inter text-sm transition-colors"
                data-testid="footer-privacy-link"
              >
                {extra.privacy_link || 'Confidentialité'}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
